import { render, staticRenderFns } from "./ztOverlay.vue?vue&type=template&id=3a65d382&scoped=true&"
import script from "./ztOverlay.vue?vue&type=script&lang=js&"
export * from "./ztOverlay.vue?vue&type=script&lang=js&"
import style0 from "../../../../styles/components/ztOverlay.css?vue&type=style&index=0&id=3a65d382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65d382",
  null
  
)

export default component.exports